<template name="launchPageList">
	<!-- 已发布的页面 从二级项目管理的发布页面迁移 -->
	<div>
		<div v-if="showPage==1">
			<div class="info-card">
				<span class="title-style">已发布页面管理</span>
			</div>

			<!-- 搜索部分 -->
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入发布页面名称"
                  v-model="searchTitle"
                 @clear="clear" clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getProductList"></el-button>
      </div>
      
			<div style="margin-top: 10px;">
				<el-table :data=" productList" style="width: 100%;text-align: center; height: 100%; " border
					ref="refTable" :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
					<el-table-column prop="id" label="id" width="81" show-overflow-tooltip align="center"/>
					<el-table-column prop="title" label="页面名称" width="300" show-overflow-tooltip align="center"/>
					<el-table-column prop="description" label="页面描述" width="300" show-overflow-tooltip align="center"/>
          <el-table-column  label="设计" width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-s-promotion" type="primary" circle @click="design(scope.row)"></el-button>
            </template>
          </el-table-column>
					<el-table-column label="修改" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-edit" type="primary" circle @click="handleEditIdBtnClick(scope.row)"></el-button>
            </template>
					</el-table-column>
					<el-table-column  label="重新发布" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-upload" type="success" circle @click="republishProduct(scope.row)"></el-button>
            </template>
					</el-table-column>
					<el-table-column  label="权限" width="110" align="center">
            <template v-slot="scope">
              <el-button type='info' icon="el-icon-s-promotion" circle @click="permissionManage(scope.row)"></el-button>
            </template>
					</el-table-column>
				</el-table>
			</div>

      <el-dialog title="修改页面名称" :visible.sync="show">
        <el-form>
          <el-form-item label="页面名称" label-width="120px">
            <el-input v-model="tempTitle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="页面描述" label-width="120px">
            <el-input v-model="tempDescription" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="show=false">取 消</el-button>
          <el-button type="primary" @click="show=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="确认重新发布页面？" :visible.sync="republishProductDialogVisible">
        <div slot="footer" class="dialog-footer">
          <el-button @click="republishProductDialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleRepublishProduct">确 定</el-button>
        </div>
      </el-dialog>

		</div>
		<launch-page-permission v-if="showPage==2" :productId="productId" :companyId="companyId" @return="comeBack"> </launch-page-permission>
	</div>
</template>

<script>
	import launchPagePermission from "./LaunchPageComponents/LaunchPagePermission"
  import API from "@/../config/api.js";
  import IMGURL from "@/../config/imgUrl.js";
	export default {
		name: "launchPageList",
		components: {
      launchPagePermission
		},
		data() {
			return {
				productList: [],
				pages: '',
				pageNum: 1,
				userId: '',
				logoProduct: IMGURL.logoProduct, //logo图片
				logoDelLaunch: IMGURL.logoDelLaunch, //logo图片
				customStyle: {
					color: '#3399ff',
				},
				customStyle2: {
					color: '#ffaa00',
				},
				customStyle3: {
					color: '#55aa00',
				},
				customStyle4: {
					color: '#aa55ff',
				},
				productId: 0, //记录权限是哪个页面的
				showPage: 1, //控制页面展示和权限页面展示

				show: false, //修改页面名字
				tempTitle: '', //记录修改框里出现的名称，传入后端
				tempProductId: 0,
				showDescription: false, //修改页面的描述
				tempDescription: '', //记录修改框里出现的描述，传入后端

				searchTitle: '', //搜索页面名字

        republishProductDialogVisible: false,//重新发布页面对话框
        republishProductItem: {},
			}
		},
		//此处定义传入的数据
		props: {
			companyId: Number,
			projectId: Number,
		},
		onLoad: function() {
			this.userId = window.localStorage.getItem('userid');
			console.log('管理已发布页面userId的值=', this.userId);

		},

		mounted() {
			this.getProductList()
		},
		methods: {
			//修改页面名字和描述
			handleEditIdBtnClick(item) {
				console.log(item)
				this.show = true
				this.tempTitle = item.title
				this.tempDescription = item.description
				this.tempProductId = item.id
				console.log('this.tempProductId', this.tempProductId)
			},

			//修改页面名字和描述与后端
			handleConfirmBtnClick() {
				console.log('this.tempProductId', this.tempProductId)
				if (!this.tempTitle) {
					this.$message({
						message: '页面名不能为空',
						type: 'warning'
					})
					this.show = false
					return
				}
				if (!this.tempDescription) {
					this.$message({
						message: '页面描述不能为空',
						type: 'warning'
					})
					this.show = false
					return
				}
				let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}
				let data = {
					companyId: this.companyId,
					id: this.tempProductId,
					title: this.tempTitle,
					description: this.tempDescription
				}
				this.$axiosRequest({
					url: API.updateProduct,
					method: 'POST',
					data: data,
					header: header,
					success: res => {
						if (res.data > 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.show = false
							for (let i = 0; i < this.productList.length; i++) {
								if (this.productList[i].id == this.tempProductId) {
									this.productList[i].title = this.tempTitle
									this.productList[i].description = this.tempDescription
									break;
								}
							}
							this.$emit('changeName', this.tempTitle, this.tempProductId) //向外抛出修改名字的事件
						} else if (res.data == 0) {
							this.$message({
								message: '标题已经存在',
								type: 'warning'
							});
							this.show = false
							return
						} else if (res.data == -2) {
							this.$message({
								message: '参数错误',
								type: 'warning'
							});
							this.show = false
							return
						} else if (res.data == -1) {
							this.$message({
								message: '保存出错',
								type: 'warning'
							});
							this.show = false
							return
						}

					}
				});
			},
      //直接跳转设计脚本的页面
      design(item){
        this.$emit('design',item)
        console.log('eeeeeeeeee',item)
      },
			//清空发布页面搜索框
			clear() {
				this.productList.length = 0; //重新刷新一下    //先把列表清空
				this.getProductPublishedList();
			},
			//权限处理
			permissionManage(item) {
				this.productId = item.id;
				this.showPage = 2;
			},
			comeBack(){
				this.showPage = 1;
				
			},
			returnBack() {
				this.$emit('return');
			},
			// getProductPublishedList() {
			// 	let header = {
			// 		"Content-Type": "application/x-www-form-urlencoded",
			// 	}
      //
			// 	let data = {
			// 		companyId: this.companyId,
			// 		projectId: this.projectId,
			// 		title: this.searchTitle,
			// 	}
      //
			// 	this.$axiosRequest({
			// 		url: API.getProductPublishedList,
			// 		method: 'POST',
			// 		data: data,
			// 		header: header,
			// 		success: res => {
			// 			this.productList = res.data["productPublishedList"];
			// 		}
			// 	});
      //
			// },
      getProductList() {
        let header = {
          "Content-Type": "application/x-www-form-urlencoded",
        }

        let data = {
          projectId: this.projectId,
          companyId: this.companyId,
          title: this.searchTitle,
          publish_status: 1, //后面打开代表发布的页面

        }
        this.$axiosRequest({
          url: API.getProductList,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log('第一页', res.data["productList"])
            this.productList = res.data["productList"];
            console.log(this.productList)
          }
        });

      },
      handleRepublishProduct(){
        let item = this.republishProductItem;
        console.log('comfirm')
        let header = {
          "Content-Type": "application/x-www-form-urlencoded",
        }
        let data = {
          id: item.id,
          companyId: this.companyId
        }
        // 获取非当前用户的其他所有用户
        this.$axiosRequest({
          url: API.publishProduct,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res.data);
            if (res.data > 0) {
              this.$message({
                message: '发布成功',
                type: 'success',
              })
              this.republishProductDialogVisible = false;
            } else if (res.data == -2) {
              this.$message({
                message: '参数出错',
                type: 'warning'
              })
            } else if (res.data == -1) {
              this.$message({
                message: '系统错误，发布失败',
                type: 'warning'
              })
            }
          }
        });
      },
			//重新发布页面
			republishProduct(item) {
				this.republishProductItem = item;
        this.republishProductDialogVisible = true;
			},
		}

	}
</script>

<style>
	.info-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
	}

	.title-style {
		font-size: 18px;
		font-weight: bold;
	}
</style>
